import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { useTranslation } from "react-i18next";

import { TextOperator } from "../menu/types";
import { TextFilterEntry } from "../use-filter-state";
import { getTextOperatorOptions } from "./constants";

export default function TextOperatorDropdown({
  entry,
  operatorLabel,
  onOperatorChange,
}: {
  entry: TextFilterEntry;
  operatorLabel: string;
  onOperatorChange: (name: string, operator: TextOperator) => void;
}) {
  const { t } = useTranslation();
  const options = getTextOperatorOptions(entry.values.length > 1);

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button
          type="button"
          className="cursor-pointer rounded px-1 text-muted hover:bg-raised hover:text-default"
        >
          {operatorLabel}
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          className="rounded-md border border-divider bg-page p-1 shadow-lg"
          sideOffset={4}
          align="start"
        >
          {options.map((opt) => (
            <DropdownMenu.Item
              key={opt.operator}
              onSelect={() => onOperatorChange(entry.fieldName, opt.operator)}
              className="flex cursor-pointer select-none items-center rounded-md px-3 py-1.5 text-xs text-default outline-none hover:bg-tint focus:bg-tint"
            >
              {t(opt.labelKey)}
            </DropdownMenu.Item>
          ))}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
